import aFileName from './aFileName';
import getShareTargetUrl from './getShareTargetUrl';

export default function getShareUrl(shareto, res) {
    return `${window.BasePath}fund/project/detail?projuuid=${res.data.uuid}`;
}
